<template>
  <div class="index-page container">
    <n-card :loading="$var('load')" style="max-width: 800px;">
      <n-form @submit="submit">
        <n-items>
          <n-input title="Название" v-bind="$form.input('title')" />
          <n-input title="Полное название" v-bind="$form.input('fullTitle')" />
          <n-input title="Краткое описание" v-bind="$form.input('desc')" />
          <n-textarea title="Описание" v-bind="$form.input('content')" />
          <n-input title="Направление" v-bind="$form.input('direction')" />
          <n-input title="Ссылка" v-bind="$form.input('url')" />
          <n-select title="Показывать на сайте" :data="actives" v-bind="$form.input('isActive', 'select')" />
          <n-input title="CloudPayments publicId" v-bind="$form.input('cloudPaymentsId')" />
          <n-upload title="Изображение" :value.sync="image" />
          <n-button color="primary" wide type="submit">Сохранить</n-button>
        </n-items>
      </n-form>
    </n-card>
  </div>
</template>

<script>
export default {
  name: 'Index',
  data: () => ({
    image: null,
    actives: [
      { id: 'true', title: 'Да', },
      { id: 'false', title: 'Нет', },
    ],
  }),
  mounted() {
    this.$form.init({
      title: '',
      fullTitle: '',
      desc: '',
      content: '',
      direction: '',
      url: '',
      cloudPaymentsId: '',
      isActive: { id: 'true', title: 'Да', },
    })
  },
  methods: {
    submit() {
      this.$var('load', true)
      if (this.image) {
        $api.files.create({ file: this.image, }).then((file) => {
          this.save(file.data.content.id).finally(() => {
            this.$var('load', false)
          })
        }).catch(() => {
          this.$var('load', false)
        })
      } else {
        this.save().finally(() => {
          this.$var('load', false)
        })
      }
    },
    save(image) {
      const data = {
        ...this.$form.get(),
        image,
        isStrategy: false,
        isActive: this.$form.get('isActive')?.id === 'true',
      }
      return $api.app.partners.create(data).then((result) => {
        this.$router.push({ name: 'partners.edit', params: { id: result.data.content.id, }, })
      })
    },
  },
}
</script>

<style lang="scss" scoped>
  .index-page {
  
  }
</style>
